import {motion} from 'framer-motion';

function AnimatedLine({text,accent,delay}) {
  return (
    <span className="block">
      {text.split(' ').filter(Boolean).map((word,index)=> (
        <span key={`${word}-${index}`} className="mr-[0.23em] inline-block overflow-hidden align-bottom pb-[0.1em]" aria-hidden="true">
          <motion.span
            className={`inline-block ${accent ? 'italic text-clay' : ''}`}
            initial={{y: '110%',rotate: 4}}
            animate={{y: 0,rotate: 0}}
            transition={{duration: 0.9,delay: delay + index * 0.09,ease: [0.22,1,0.36,1]}}
          >
            {word}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

function SplitText({text,accent='',className='',delay=0}) {
  return (
    <span className={className} aria-label={`${text} ${accent}`.trim()}>
      <AnimatedLine text={text} accent={false} delay={delay} />
      {accent && <AnimatedLine text={accent} accent delay={delay + text.split(' ').length * 0.09} />}
    </span>
  );
}

export default SplitText;
